import { useEffect, useMemo } from 'react'

import { useLoaderData, useNavigate } from '@tanstack/react-router'
import { BankApplicationPaths } from 'commons/constants/routes'
import { PortalName } from 'commons/types/enums'
import { CircularProgress, Link } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { Page, PageFace } from 'ui/components/Page'

import { OnboardingForm } from '../../components'
import { Footer } from '../../components/OnboardingForm/Footer'
import { OnboardingFormContext } from '../../components/OnboardingForm/OnboardingFormContext'
import { useOnboardingForm } from '../../components/OnboardingForm/useOnboardingForm'
import { OnboardingFormLoaderReturn } from '../../types'

const BankOnboardingForm = () => {
  const loaderData: OnboardingFormLoaderReturn = useLoaderData({
    // @ts-ignore
    from: '/_app/onboarding/applications/edit/$applicationId'
  })
  const { applicationId, applicationData } = loaderData
  const navigate = useNavigate()

  const { state, Confirmations } = useOnboardingForm({ portalName: PortalName.BP, applicationId, applicationData })

  const {
    state: { isCurrentStepEditEnable, applicationStatus, applicationName },
    ui: { ErrorMessagesDialog, isOnboardingFormEnable },
    isWebpageFetchLock
  } = state

  const applicationDetailsUrlParams = useMemo(
    () => ({ to: BankApplicationPaths.DETAILS, params: { id: applicationId } }),
    [applicationId]
  )

  useEffect(() => {
    if (isWebpageFetchLock && !isCurrentStepEditEnable) {
      // @ts-ignore
      navigate(applicationDetailsUrlParams)
    }
  }, [applicationDetailsUrlParams, isCurrentStepEditEnable, isWebpageFetchLock, navigate])

  if (!isWebpageFetchLock) {
    return <CircularProgress centered />
  }

  return (
    <>
      <OnboardingFormContext.Provider value={state}>
        <Page
          actions={
            // @ts-ignore
            <Link {...applicationDetailsUrlParams}>
              <Button face="inherit white">Back to application</Button>
            </Link>
          }
          footer={<Footer />}
          face={PageFace.SECONDARY}
          title={applicationStatus}
          subTitle={applicationName}
        >
          {isOnboardingFormEnable && <OnboardingForm />}
          <ErrorMessagesDialog />
        </Page>
      </OnboardingFormContext.Provider>

      {Confirmations.CompanyDelete()}
      {Confirmations.ContactDelete()}
      {Confirmations.AtmDelete()}
      {Confirmations.LicenseDelete()}
    </>
  )
}

export default BankOnboardingForm
